module.exports = __webpack_public_path__ + "img/logo.998dd0e5.svg";